export const NextArrowCircle = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="89" viewBox="0 0 90 89" fill="none">
            <rect x="0.916992" y="1" width="87" height="87" rx="43.5" stroke="#0095DA" strokeWidth="1.5" />
            <circle cx="44.667" cy="44.5" r="44.5" fill="url(#paint0_linear_3180_3031)" fillOpacity="0.8" />
            <path fillRule="evenodd" clipRule="evenodd" d="M46.6857 33.326C47.1213 32.8913 47.8274 32.8913 48.263 33.326L58.6733 43.713C58.8825 43.9216 59 44.2047 59 44.4999C59 44.795 58.8825 45.0781 58.6733 45.2869L48.263 55.674C47.8274 56.1087 47.1213 56.1087 46.6857 55.674C46.2501 55.2394 46.2501 54.5347 46.6857 54.1001L55.1918 45.6128H31.1154C30.4994 45.6128 30 45.1145 30 44.4999C30 43.8852 30.4994 43.387 31.1154 43.387H55.1918L46.6857 34.8998C46.2501 34.4652 46.2501 33.7606 46.6857 33.326Z" fill="white" />
            <defs>
                <linearGradient id="paint0_linear_3180_3031" x1="75.7201" y1="15.9598" x2="31.9962" y2="85.2971" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#50C8FF" />
                    <stop offset="1" stopColor="#0095DA" />
                </linearGradient>
            </defs>
        </svg>
    )
}